import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon MessageIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const MessageIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 18 17">
      <path
        d="M3.82143 1.5C2.53934 1.5 1.5 2.58661 1.5 3.92701V9.92833C1.5 11.2687 2.53934 12.3553 3.82143 12.3553H4.0794L4.71429 14.5L7.02628 12.3553L14.1786 12.3553C15.4607 12.3553 16.5 11.2687 16.5 9.92833V3.92701C16.5 2.58661 15.4607 1.5 14.1786 1.5L3.82143 1.5Z"
        stroke="#503291"
        strokeWidth={1.25}
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default MessageIcon
